import { useI18n } from "@/i18n";

const LANGS = [
  { code: "es", label: "ES" },
  { code: "en", label: "EN" },
  { code: "zh", label: "中" },
  { code: "ko", label: "한" },
];

export default function LangToggle() {
  const { lang, setLang } = useI18n();
  return (
    <>
      {/* Mobile: compact native select to save horizontal space */}
      <div className="sm:hidden flex items-center" data-testid="lang-toggle">
        <select
          value={lang}
          onChange={(e) => setLang(e.target.value)}
          className="bg-transparent text-gold text-xs font-label px-1 py-1 rounded outline-none border-0 appearance-none cursor-pointer"
          aria-label="Idioma"
          data-testid="lang-select"
          style={{ backgroundImage: "none" }}
        >
          {LANGS.map((l) => (
            <option key={l.code} value={l.code} className="bg-obsidian text-gold-light">
              {l.label}
            </option>
          ))}
        </select>
      </div>
      {/* Desktop / tablet: inline toggle bar */}
      <div
        className="hidden sm:flex items-center text-xs font-label"
        data-testid="lang-toggle-desktop"
      >
        {LANGS.map((l, i) => (
          <span key={l.code} className="flex items-center">
            {i > 0 && (
              <span className="text-faded mx-0.5">/</span>
            )}
            <button
              onClick={() => setLang(l.code)}
              className={`px-2 py-1 rounded transition ${lang === l.code ? "text-gold" : "text-faded hover:text-muted"}`}
              data-testid={`lang-${l.code}`}
            >
              {l.label}
            </button>
          </span>
        ))}
      </div>
    </>
  );
}
